
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


const headersCryptoApi = {
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': '6702e24fa6msh192df11759566bbp1232f5jsn1096fa669d01'
}

const baseUrl = "https://coinranking1.p.rapidapi.com";

const createRequest = (url: string) => ({ url, headers: headersCryptoApi })

export const cryptoApi = createApi({
    reducerPath: "cryptoApi",
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (build) => ({
        getCoins: build.query<any, number>({
            query: (count:number = 100) => createRequest(`/coins?limit=${count}`)
        }),
        getCoinDetails : build.query<any,string>({
            query: (coinId:string) => createRequest(`/coin/${coinId}`)
        }),
        getCoinHistory : build.query({
            query: ({coinId, timePeriod}) => createRequest(`/coin/${coinId}/history/${timePeriod}`)
        }),
    })
});